import { changeToasterState, toggleModal } from '../../../Store/layoutSlice';
import { useAppDispatch, useAppSelector } from '../../../Store/store';
import { useDeleteBankAccountMutation } from '../../../Store/bankaccount';
import { currentBankAccountSelector, currentCompanySelector } from '../../../Store/paramsBagSlice';
import { BankAccount } from '../../../Model/BankAccount';
import { Company } from '../../../Model/Company';
import { TOASTER_STATE } from '../../../Model/Enums';

export const useBankAccountDeleteForm = () => {
  const dispatch = useAppDispatch();

  const currentBankAccount = useAppSelector(currentBankAccountSelector) as BankAccount;
  const currentCompany = useAppSelector(currentCompanySelector) as Company;
  const [deleteBankAccount, { isLoading }] = useDeleteBankAccountMutation();
  const onSubmit = async (event) => {
    event.preventDefault();
    try {
      await deleteBankAccount({
        accountNr: currentBankAccount?.accountNr,
        originate: currentBankAccount?.originate,
        _id: currentCompany?._id,
      }).unwrap();
    } catch (e) {
      dispatch(changeToasterState(TOASTER_STATE.DELETE_COMPANY_FAILED));
    } finally {
      dispatch(toggleModal());
    }
  };

  return { onSubmit, isLoading, originate: currentBankAccount.originate };
};
